import type { Breadcrumb } from '@sentry/react';
import type { BreadcrumbHint } from '@sentry/react';

const BREADCRUMB_URL_SEGMENTS_TO_IGNORE = [
  'alchemy',
  'sound.xyz',
  '_next',
  'rum.browser-intake-datadoghq.com',
  'api.segment.io',
  'events.statsigapi.net',
  'app.dynamic.xyz',
];

export const beforeBreadcrumb = (breadcrumb: Breadcrumb, hint: BreadcrumbHint | undefined) => {
  if (['fetch'].includes(breadcrumb.category || '')) {
    const url = hint?.response?.url;
    for (const urlSegment of BREADCRUMB_URL_SEGMENTS_TO_IGNORE) {
      if (url?.includes(urlSegment)) {
        return null;
      }
    }
  }
  return breadcrumb;
};
